import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("monitoring.management_title"))),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: { click: _vm.onDownloadCSV },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.download"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("btns.filter"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(
                  "div",
                  { ref: "wrapper2", attrs: { id: "wrapper2" } },
                  [
                    _c(VDataTable, {
                      directives: [
                        {
                          name: "scrollable-table",
                          rawName: "v-scrollable-table",
                        },
                      ],
                      key: _vm.key_table,
                      staticClass: "table-inca table-reference",
                      attrs: {
                        items: _vm.filterUsers,
                        headers: _vm.headers,
                        "single-expand": "",
                        "hide-default-footer": "",
                        "show-expand": "",
                        loading: _vm.loading_data,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.data-table-expand",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                "td",
                                { staticClass: "text-start" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      attrs: {
                                        small: "",
                                        dense: "",
                                        color: "secondary",
                                        outlined: "",
                                        rounded: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.show_details(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("monitoring.show_details")
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              item.status == "Active"
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "btn-icon-inca",
                                      attrs: {
                                        icon: "",
                                        size: "sm",
                                        variant: "outline-secondary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showModalWithData(
                                            item,
                                            _vm.MODAL_CONFIRM_REMOVE_ACCESS
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-delete"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            item.status == "Active"
                                              ? _c(
                                                  VBtn,
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "btn-icon-inca",
                                                        attrs: {
                                                          icon: "",
                                                          size: "sm",
                                                          variant:
                                                            "outline-secondary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.ReprocessAccess(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [_vm._v("icon-renew")]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v("Volver a dar acceso")])]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("pagination-firestore", {
                  key: _vm.key_pagination,
                  attrs: { pagination: _vm.pagination },
                  on: { changePagina: _vm.changePage },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filter_enabled
          ? _c(
              "div",
              { staticClass: "col-md-3 d-none d-md-block pl-0" },
              [
                _c(
                  VCard,
                  { staticClass: "filters-inca" },
                  [
                    _c(
                      VCardTitle,
                      {
                        staticClass: "pointer",
                        on: {
                          click: function ($event) {
                            _vm.collapse_filter = !_vm.collapse_filter
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("monitoring.search_filters")))]
                    ),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _vm.isDomainItc
                                  ? _c("organizacion-component", {
                                      attrs: {
                                        custom_orgs: _vm.list_orgs,
                                        show_all: false,
                                        rules: [],
                                      },
                                      model: {
                                        value: _vm.domain_filter,
                                        callback: function ($$v) {
                                          _vm.domain_filter = $$v
                                        },
                                        expression: "domain_filter",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t("monitoring.email_benefited"),
                                    placeholder: _vm.$t(
                                      "monitoring.email_benefited_ph"
                                    ),
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.movePage(_vm.TYPE_EVENT_SEARCH)
                                    },
                                  },
                                  model: {
                                    value: _vm.emailBenefited,
                                    callback: function ($$v) {
                                      _vm.emailBenefited = $$v
                                    },
                                    expression: "emailBenefited",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t("monitoring.email_applicant"),
                                    placeholder: _vm.$t(
                                      "monitoring.email_applicant_ph"
                                    ),
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.movePage(_vm.TYPE_EVENT_SEARCH)
                                    },
                                  },
                                  model: {
                                    value: _vm.emailApplicant,
                                    callback: function ($$v) {
                                      _vm.emailApplicant = $$v
                                    },
                                    expression: "emailApplicant",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    placeholder: _vm.$t(
                                      "monitoring.tablas_monitoring.table_id"
                                    ),
                                    label: _vm.$t(
                                      "monitoring.tablas_monitoring.table_id"
                                    ),
                                  },
                                  model: {
                                    value: _vm.tableId,
                                    callback: function ($$v) {
                                      _vm.tableId = $$v
                                    },
                                    expression: "tableId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "mb-2 text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.movePage(
                                          _vm.TYPE_EVENT_CLEAN
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary ",
                                    on: {
                                      click: function ($event) {
                                        return _vm.movePage(
                                          _vm.TYPE_EVENT_SEARCH
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "b-modal",
        {
          ref: "wrng-modal",
          attrs: { id: "wrng-modal", title: _vm.wrnngmsg, "hide-footer": "" },
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "active ml-2",
                  attrs: {
                    id: "popover-target-1",
                    type: "submit",
                    variant: "primary",
                    size: "sm",
                  },
                  on: { click: _vm.hideModalWrng },
                },
                [
                  _c("span", [
                    _c("i", { staticClass: "material-icons md-16" }, [
                      _vm._v("send"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("dialog-confirmation-component", {
        ref: _vm.MODAL_CONFIRM_REMOVE_ACCESS,
        attrs: { title: _vm.$t("monitoring.remove_access") },
        on: {
          onConfirm: function ($event) {
            return _vm.removeAccess(_vm.item)
          },
        },
      }),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", id: _vm.MODAL_RENEW_ACCESS, "hide-footer": "" },
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v(_vm._s(_vm.$t("botones.boton_renew_access"))),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-access-request", {
                attrs: { tplToWork: _vm.tplToUpdate },
                on: {
                  submit: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_RENEW_ACCESS)
                  },
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_RENEW_ACCESS)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "modalShowDetails",
          attrs: { title: _vm.$t("monitoring.show_details"), width: 1200 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VOverlay,
                { attrs: { value: _vm.isLoading } },
                [
                  _c(VProgressCircular, {
                    attrs: { indeterminate: "", size: "64" },
                  }),
                ],
                1
              ),
              _c(
                VTabs,
                {
                  staticClass: "elevation-1",
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(VTab, [_vm._v("Detalles de acceso")]),
                  _c(VTab, [_vm._v("Detalles de permisos")]),
                  _c(VTab, [_vm._v("Columnas")]),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    [
                      _c("div"),
                      _c(
                        VForm,
                        {
                          ref: "form",
                          staticClass: "form-inca",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            VContainer,
                            [
                              _c(
                                VRow,
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].tblProjectId
                                              : "",
                                          label: "Proyecto de la Tabla",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].tblDatasetId
                                              : "",
                                          label: "Dataset de la Tabla",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].tblObjectId
                                              : "",
                                          label: "Tabla",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].viwProjectId
                                              : "",
                                          label: "Proyecto de la Vista",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].viwDatasetId
                                              : "",
                                          label: "Dataset de la Vista",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].viwObjectId
                                              : "",
                                          label: "Vista",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].creationTime
                                              : "",
                                          label: "Fecha de Creación",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0]
                                                  .permissionExpirationDate
                                              : "",
                                          label: "Fecha de Expiración",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(VTextField, {
                                        attrs: {
                                          value:
                                            _vm.item.objects &&
                                            _vm.item.objects.length
                                              ? _vm.item.objects[0].approvalUser
                                              : "",
                                          label: "Usuario Aprobador",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c("div", [
                        _c("p", [
                          _c("b", [
                            _vm._v(
                              _vm._s("Proyecto: " + _vm.item_view.viwProjectId)
                            ),
                          ]),
                          _c("br"),
                          _c("b", [
                            _vm._v(
                              _vm._s("Dataset: " + _vm.item_view.viwDatasetId)
                            ),
                          ]),
                          _c("br"),
                          _c("b", [
                            _vm._v(
                              _vm._s("Vista: " + _vm.item_view.viwObjectId)
                            ),
                          ]),
                        ]),
                      ]),
                      _c("b", [_vm._v("PERMISOS OTORGADOS")]),
                      _c(VDataTable, {
                        staticClass: "table-inca mb-0",
                        attrs: {
                          items: _vm.access_list,
                          headers: _vm.headers3,
                          "tbody-tr-class": _vm.rowClass,
                          "pagination-disabled": "",
                          "hide-default-footer": "",
                          small: "",
                          dense: "",
                        },
                      }),
                      _c("b", [_vm._v("VISTAS AUTORIZADAS")]),
                      _c(VDataTable, {
                        staticClass: "table-inca mb-0",
                        attrs: {
                          items: _vm.authorized_views,
                          headers: _vm.headers4,
                          "tbody-tr-class": _vm.rowClass,
                          "pagination-disabled": "",
                          "hide-default-footer": "",
                          small: "",
                          dense: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VTabItem,
                    [
                      _c("b", [_vm._v("COLUMNAS DE LA VISTA AUTORIZADAS")]),
                      _c(VDataTable, {
                        key: _vm.key_table,
                        staticClass: "table-inca",
                        attrs: {
                          items: _vm.columns_list,
                          headers: _vm.headers5,
                          "hide-default-footer": "",
                          small: "",
                          dense: "",
                          "items-per-page": _vm.paginationColumnsViews.limit,
                          page: _vm.paginationColumnsViews.current,
                          "sort-by": _vm.paginationColumnsViews.sort_by,
                          "sort-desc": _vm.paginationColumnsViews.sort_desc,
                        },
                        on: {
                          pagination: function ($event) {
                            _vm.paginationColumnsViews.total =
                              $event.itemsLength
                          },
                          "update:page": function ($event) {
                            return _vm.$set(
                              _vm.paginationColumnsViews,
                              "current",
                              $event
                            )
                          },
                        },
                      }),
                      _c("pagination-vue", {
                        attrs: { pagination: _vm.paginationColumnsViews },
                        on: { changePagina: _vm.changePage },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }